import { render, staticRenderFns } from "./PlatformSlider.vue?vue&type=template&id=1818b214&"
import script from "./PlatformSlider.vue?vue&type=script&lang=js&"
export * from "./PlatformSlider.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlatformSlider.vue"
export default component.exports